// extracted by mini-css-extract-plugin
export default {"mono":"AddTagsComponent_mono__vp5Dl","rowTight":"AddTagsComponent_rowTight__fjOO7"};